import React, { Component } from "react"
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import ApplicationLayout from "../../layouts/ApplicationLayout"
import {
  Header,
  Segment,
  Input,
  Button,
  Checkbox as SematicCheckbox,
  Portal
} from "semantic-ui-react"
import { withTranslation } from "react-i18next"
import { EVENTS, FILTER_OPTIONS_VEHICLE, VIN } from "../../constants/application"
import CustomNotification from "../../components/shared/CustomNotification"
import { NOTIFICATION_TYPE } from "../../constants/notification"
import {
  agGridColumnDefs,
  agGridFMCColumnDefs,
  agGridRowData,
  DEACTIVE
} from "../../constants/vehicles"
import { isFleetAdvise, isFleetcor, isMobilease } from "../../helpers/affiliationHelpers"
import { AgGridReact } from "ag-grid-react"
import CustomNoRowsOverlay from "../../components/shared/CustomNoRowsOverlay"
import { FR_LOCALE } from "../../constants/users"
import frGrid from "../../locales/fr-ca/grid.json"
import enGrid from "../../locales/en/grid.json"
import * as agGridHelpers from "../../helpers/agGridHelpers"
import debounce from "debounce"
import FMCTransactionsShimmer from "../../views/accounts/FMCTransactionsShimmer"
import { navigationPaths } from "../../constants/paths"
import { logFirebaseAnalyticsScreenName } from "../../helpers/googleAnalyticsHelpers"
import { getRouteNameFromUrl } from "../../helpers/segmentHelpers"
import ReactSVG from "react-svg"
import ReactTooltip from "react-tooltip"
import Stats from "../../components/vehicles/Stats"
import VehicleModal from "../../components/vehicles/VehicleModal"
import BulkActivateDeactivate from "../../components/vehicles/BulkActivateDeactivate"
import { getVehicleClassfiedData } from "../../helpers/vehicleHelpers"
import i18n from "../../utilities/i18n"
import VehicleSearch from "../../components/vehicles/VehicleSearch"

class VehicleIndex extends Component {
  constructor(props) {
    super(props)
    this.state = {
      search_text: "",
      showDropdown: false,
      selectedOption: VIN,
      sizeToFit: false,
      prevBottomDisplayedRowIndex: 0,
      page: 1,
      showGrid: true,
      showInactiveVehicles: false,
      checkedVehicles: new Set()
    }
    this.wrapperRef = React.createRef()
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.debouncedOnSizeToFitChange = debounce(this.onSizeToFitChange, 100)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.redirectToVehicleShow = this.redirectToVehicleShow.bind(this)
    this.handleActivateDeactivateRootCheckbox = this.handleActivateDeactivateRootCheckbox.bind(this)
    this.handleCellCheckboxChange = this.handleCellCheckboxChange.bind(this)
    this.handleBulkCheckBox = this.handleBulkCheckBox.bind(this)
    this.loadAllVehicles = this.loadAllVehicles.bind(this)
  }

  setCheckedVehicles = (checkedVehicles) => {
    this.setState({
      checkedVehicles: checkedVehicles
    })
  }

  handleActivateDeactivateRootCheckbox(isChecked) {
    const updatedRowData = this.state.filteredVehicles.map((row) => ({
      ...row,
      checked: isChecked
    }))
    this.setState({ filteredVehicles: updatedRowData, rootCheckbox: isChecked })
  }

  handleCellCheckboxChange = (rowIndex, isChecked) => {
    const updatedRowData = [...this.props.vehicles]
    updatedRowData[rowIndex].checked = isChecked
    const allChecked = updatedRowData.every((row) => row.checked)
    if (!allChecked) {
      this.setState({ rootCheckbox: false })
    }
    this.setState({ filteredVehicles: updatedRowData })
    return updatedRowData.findIndex((vehicle) => vehicle.checked) > -1
  }

  handleInputClick = (e) => {
    this.setState({ showDropdown: true })
  }

  componentDidMount() {
    logFirebaseAnalyticsScreenName(getRouteNameFromUrl())
    document.addEventListener(EVENTS.MOUSEDOWN, this.handleClickOutside)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.fleet?.id && this.props.fleet?.id && this.api) {
      this.loadAllVehicles({ page: 1, is_active: !this.state.showInactiveVehicles })
    }
  }

  handleVehicleActivation = async (status = DEACTIVE) => {
    const vehicles = this.state.filteredVehicles.filter((vehicle) =>
      [...this.state.checkedVehicles].includes(vehicle.id)
    )
    const { activeVehicle, deactiveVehicle } = getVehicleClassfiedData(vehicles)
    this.setState({ isBulkApiInProgress: true })

    this.props.dispatch({
      type: "BULK_ACTIVATE_DEACTIVATE_VEHICLE",
      payload: {
        vehicleIds:
          status === DEACTIVE
            ? activeVehicle && activeVehicle.map((vehicle) => vehicle.id)
            : deactiveVehicle && deactiveVehicle.map((vehicle) => vehicle.id),
        status: status
      },
      callback: this.loadAllVehicles.bind(this)
    })
  }

  loadAllVehicles = async (payload) => {
    requestAnimationFrame(() => {
      this.api?.showLoadingOverlay()
    })
    const { id } = this.props.fleet
    if (!payload) {
      payload = {}
    }
    if (!payload?.page) {
      payload.page = 1
    }
    await this.props.dispatch({
      type: "VEHICLES_LOAD_SAGA",
      payload: {
        is_active: !this.state.showInactiveVehicles,
        ...payload,
        pagination: true,
        options: {
          fleet_id: id
        },
        order_column: this.state.sortModel?.[0]?.colId,
        order_direction: this.state.sortModel?.[0]?.sort
      },
      callback: this.afterLoadVehicles
    })
    this.setState({ page: payload.page })
  }

  componentWillUnmount() {
    document.removeEventListener(EVENTS.MOUSEDOWN, this.handleClickOutside)
  }

  handleClickOutside(event) {
    if (
      this.state.showDropdown &&
      this.wrapperRef &&
      !this.wrapperRef.current.contains(event.target)
    ) {
      this.setState({ showDropdown: false })
    }
  }

  onTextChange = (event) => {
    const { dispatch } = this.props
    this.setState({ search_text: event.target.value })

    if (event.target.value == "") {
      this.setState({ search_text: "", showDropdown: false })
      this.loadAllVehicles({
        page: 1,
        is_active: !this.state.showInactiveVehicles,
        order_column: this.state.sortModel?.[0]?.colId,
        order_direction: this.state.sortModel?.[0]?.sort
      })
    }
  }

  handleKeyDown(event) {
    if (event.key === EVENTS.ENTER) {
      this.onSearch()
    }
  }

  onSearch = () => {
    const { t } = this.props
    const { search_text, selectedOption, showDropdown } = this.state
    if (search_text !== "" && search_text.length >= 3) {
      this.loadAllVehicles({
        page: 1,
        query: search_text,
        search_type: selectedOption,
        is_active: !this.state.showInactiveVehicles,
        order_column: this.state.sortModel?.[0]?.colId,
        order_direction: this.state.sortModel?.[0]?.sort
      })
    } else {
      return CustomNotification(NOTIFICATION_TYPE.DANGER, "", t("invalidSearchValue"), t)
    }
  }

  handleOptionChange = (e) => {
    this.setState({ selectedOption: e.target.value })
  }

  redirectToVehicleShow = (e) => {
    e.preventDefault()
  }

  editCellRenderer = (cellParams) => {
    const vehicle = cellParams.value
    const { loadVehicles, t } = this.props
    if (vehicle.fleetcor_enrolled == true) {
      return (
        <VehicleModal completionCallback={loadVehicles} vehicle={vehicle}>
          <span className="link">{t("common:editLabel")}</span>
        </VehicleModal>
      )
    } else return <></>
  }

  deleteCellRenderer = (cellParams) => {
    const vehicle = cellParams.value
    const { t } = this.props
    return (
      <span
        className="link"
        onClick={(event) => {
          event.preventDefault()
          this.onDeleteVehicle(vehicle.id, t)
        }}
      >
        {t("deleteLabel")}
      </span>
    )
  }

  onDeleteVehicle = (vehicleId, t) => {
    const confirmed = window.confirm(t("deleteConfirmLabel"))

    if (confirmed) {
      this.props.dispatch({
        type: "VEHICLE_DELETE_SAGA",
        payload: {
          vehicleId: vehicleId
        },
        callback: this.afterDeleteVehicle.bind(this)
      })
    }
  }

  afterDeleteVehicle = (status, data) => {
    if (status === "success") {
      this.onDeleteVehicleSuccess(data)
    } else {
      this.onRequestFailure(data)
    }
  }

  onDeleteVehicleSuccess(data) {
    CustomNotification(data.alertType, i18n.t("settings:successLable"), data.alertMessage, i18n.t)
    this.loadAllVehicles({
      page: this.state.page,
      is_active: !this.state.showInactiveVehicles,
      order_column: this.state.sortModel?.[0]?.colId,
      order_direction: this.state.sortModel?.[0]?.sort
    })
  }

  onRequestFailure = (data) => {
    CustomNotification(data.alertType, i18n.t("settings:errorLabel"), data.alertMessage, i18n.t)
  }

  deactivateCellRenderer = (cellParams) => {
    const vehicle = cellParams.value
    const { loadVehicles, t, currentUser } = this.props
    // splitIOhere
    return isFleetcor() ? (
      vehicle.fleetcor_enrolled == false ? (
        this.state.sfo ? (
          <Button
            className="white-button"
            onClick={(event) => {
              event.preventDefault()
              this.setCurrentCard(vehicle)
            }}
          >
            Enroll Now
          </Button>
        ) : (
          <VehicleModal
            deactivate={true}
            editActiveVehicleFields={true}
            completionCallback={() => this.redrawGrid()}
            vehicle={vehicle}
          >
            <Button className="white-button">Enroll Now</Button>
          </VehicleModal>
        )
      ) : (
        <Button className="white-button" disabled>
          Enrolled
        </Button>
      )
    ) : (
      <div
        role="presentation"
        onClick={() => this.props.onDeactivateVehicle(vehicle.is_active, vehicle.id, t)}
      >
        <SematicCheckbox toggle checked={vehicle.is_active} />
      </div>
    )
  }

  checkboxBulkRender = (cellParams) => {
    const { value } = cellParams
    return (
      <SematicCheckbox
        checked={this.state.checkedVehicles.has(value.id)}
        onChange={(_, { checked }) => {
          const isRootChecked = this.handleCellCheckboxChange(value.index, checked)
          const checkedVehicles = new Set([...this.state.checkedVehicles, value.id])
          if (!checked) {
            checkedVehicles.delete(value.id)
          }
          this.setCheckedVehicles(checkedVehicles)
          this.setState({ openBulkPortal: isRootChecked || checked })
        }}
        onClick={(event) => {
          event.preventDefault()
        }}
      />
    )
  }

  handleActivateDeactivateRootCheckbox(isChecked) {
    const updatedRowData = this.props.vehicles.map((row) => ({
      ...row,
      checked: isChecked
    }))
    this.setState({ filteredVehicles: updatedRowData, rootCheckbox: isChecked })
  }

  handleBulkCheckBox(isChecked) {
    this.setState({ openBulkPortal: isChecked })
    const checkedVehiclesList = isChecked
      ? this.state.quickFilterText
        ? this.state.filteredItems?.map((item) => item.id)
        : this.props.vehicles?.map((item) => item.id)
      : new Set()

    this.setCheckedVehicles(new Set(checkedVehiclesList))
    this.handleActivateDeactivateRootCheckbox(isChecked)
  }

  callToActionRenderer = (cellParams) => {
    const vehicle = cellParams.data.vehicle
    const vehicleId = cellParams.data.id
    const ctaValsPresent = vehicle.year && vehicle.make && vehicle.model
    const presentValsString = `${vehicle.year} ${vehicle.make} ${vehicle.model}`
    const isActiveVehicle = cellParams.data.vehicle.is_active === false

    const vehicleDetailsLink = (
      <Link
        className={`ag-grid-link-column ${isActiveVehicle ? "deactivated" : ""}`}
        to={navigationPaths.vehicleShow(vehicleId)}
      >
        <div>{presentValsString}</div>
      </Link>
    )
    const { t, loadVehicles } = this.props
    const ctaValsModal = isFleetcor() ? <> - </> : <></>

    return <div>{ctaValsPresent ? vehicleDetailsLink : ctaValsModal}</div>
  }

  // NOTE: This is used over linking from ag-grid's onRowSelected, because clicking a column button (i.e. Edit), will
  // fire both the row and column click handlers. This will take you to the expected edit page, but polutes the
  // navigation stack, and breaks expected back button functionality.
  // NOTE: This is not needed without linking, as it just wraps the ag-grid default render with a link.
  defaultCellRenderer(cellParams) {
    const isActiveVehicle =
      cellParams.data.vehicle.is_active === false ||
      (isFleetcor() && cellParams.data.vehicle.fleetcor_enrolled === false)
    return (
      <div
        className={`ag-grid-link-column ${isActiveVehicle ? "deactivated" : ""} ${
          cellParams.colDef.field === "vin" ? "column-vin" : ""
        }`}
      >
        <div>{cellParams.value}</div>
        {cellParams.colDef.field === "vin" && cellParams.value && (
          <>
            <ReactTooltip
              id={"vin-copy-" + cellParams.value}
              effect={"solid"}
              type={"dark"}
              place={"right"}
              class={"vin-copy-tooltip"}
              afterShow={(e) => {
                e.preventDefault()
                navigator.clipboard.writeText(cellParams.value)
              }}
            >
              <p style={{ color: "white" }}>Copied!</p>
            </ReactTooltip>
            <div
              data-for={"vin-copy-" + cellParams.value}
              data-tip
              data-event="click"
              data-event-off={"mouseout"}
            >
              <ReactSVG src={"images/copy-icon.svg"} className="vin-copy" />
            </div>
          </>
        )}
      </div>
    )
  }

  onGridReady = (params) => {
    const { sizeToFit } = this.state
    this.api = params.api
    this.columnApi = params.columnApi
    if (sizeToFit) params.api.sizeColumnsToFit()
    window.addEventListener("resize", () => sizeToFit && this.api.sizeColumnsToFit())
    this.api.showLoadingOverlay()

    if (this.props.fleet?.id) {
      setTimeout(() => {
        this.loadAllVehicles({ page: 1, is_active: !this.state.showInactiveVehicles })
      }, 0)
    }
  }

  setFilteredItems = () =>
    this.setState({ filteredItems: this.api.getModel().rowsToDisplay.map((r) => r.data) })

  onSizeToFitChange = (event, syntheticEvent) => {
    this.setState({ sizeToFit: syntheticEvent.checked })
    if (syntheticEvent.checked) this.api.sizeColumnsToFit()
    else this.redrawGrid()
  }

  redrawGrid() {
    this.setState({ showGrid: false })
    setTimeout(() => this.setState({ showGrid: true }), 500)
  }

  handlePageChange = async ({ newPage }) => {
    const { selectedOption, search_text } = this.state
    if (newPage) {
      if (search_text) {
        this.loadAllVehicles({
          page: newPage,
          query: search_text,
          filter: { filterType: "search_type", filterValue: selectedOption },
          is_active: !this.state.showInactiveVehicles,
          order_column: this.state.sortModel?.[0]?.colId,
          order_direction: this.state.sortModel?.[0]?.sort
        })
      } else {
        this.loadAllVehicles({
          page: newPage,
          is_active: !this.state.showInactiveVehicles,
          order_column: this.state.sortModel?.[0]?.colId,
          order_direction: this.state.sortModel?.[0]?.sort
        })
      }
    }
  }

  afterLoadVehicles = (message) => {
    if (this.props.vehicles?.length === 0) {
      this.api.showNoRowsOverlay()
    } else {
      this.api.hideOverlay()
    }

    if (this.state.sortModel?.length) {
      this.columnApi.applyColumnState({
        state: this.state.sortModel?.map((s) => ({
          colId: s.colId,
          sort: s.sort
        })),
        defaultState: { sort: null }
      })
    }
    this.setState({
      checkedVehicles: new Set(),
      rootCheckbox: false,
      openBulkPortal: false
    })
  }

  handleRowClick = (event) => {
    if (event.event.defaultPrevented) return
    const rowData = event.data
    this.props.history.push({
      pathname: navigationPaths.vehicleShow(rowData.id)
    })
  }

  goToFirstPage = () => {
    const currentPage = this.state.page

    if (currentPage !== 1) {
      this.handlePageChange({ newPage: 1 })
    }
  }

  goToPreviousPage = () => {
    const currentPage = this.state.page
    if (currentPage > 1) {
      this.handlePageChange({ newPage: currentPage - 1 })
    }
  }

  goToNextPage = () => {
    const currentPage = this.state.page
    if (currentPage < this.props.totalPages) {
      this.handlePageChange({ newPage: currentPage + 1 })
    }
  }

  goToLastPage = () => {
    const totalPage = this.props.totalPages
    const currentPage = this.state.page

    if (currentPage !== totalPage) {
      this.handlePageChange({ newPage: totalPage })
    }
  }

  onSortChanged = () => {
    const sortModel = this.api.getSortModel()
    this.setState({ sortModel })

    this.handlePageChange({ newPage: 1 })
  }

  render() {
    const { t, vehicles, language, fleet, totalVehicleCount, currentUser } = this.props
    const { sizeToFit, search_text, selectedOption, showDropdown, quickFilterText, showGrid } =
      this.state
    const getRowStyle = (params) => {
      if (
        params.data.vehicle.is_active === false ||
        (isFleetcor() && params.data.vehicle.fleetcor_enrolled === false)
      ) {
        return { background: "#f7f7f7" }
      }
    }
    return (
      <ApplicationLayout>
        <div className="settings-container">
          <span />
          <Stats
            fleet={fleet}
            vehicles={vehicles}
            language={language}
            totalVehicleCount={totalVehicleCount}
            currentUser={currentUser}
          />
          <Header size="small" className={"dash-hd"}>
            {t("myVehiclesLabel")}
          </Header>
          <Segment className={"ag-theme-material fmc-vehicle-table-height"}>
            <div className="vehicle-search">
              <div className="search-input-parent">
                <div className="search-input-box-vehicle">
                  <Input
                    className="search search-fleet"
                    icon="search"
                    onClick={this.handleInputClick}
                    onChange={this.onTextChange}
                    placeholder={t("SearchVehicleLabel")}
                    onKeyDown={this.handleKeyDown}
                  />
                  {showDropdown && (
                    <div className="filter-options-parent" ref={this.wrapperRef}>
                      <p>{t("iAmLookingForLabel")}</p>
                      <div className="filter-options">
                        {FILTER_OPTIONS_VEHICLE.filter((option) => {
                          return !(!isFleetcor() && option?.key?.toLowerCase()?.includes("card"))
                        }).map((option) => (
                          <label key={option.value}>
                            <input
                              type="radio"
                              value={option.value}
                              checked={option.value === selectedOption}
                              onChange={this.handleOptionChange}
                              className={isFleetAdvise() || isMobilease() ? "radio-btn-color" : ""}
                            />
                            {option.key}
                            <br />
                          </label>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
                <Button disabled={!(search_text.length >= 1)} onClick={() => this.onSearch()}>
                  {t("search")}
                </Button>
                <SematicCheckbox
                  style={{ paddingTop: "10px", marginLeft: "10px" }}
                  label={t("sizeToFitLabel")}
                  onChange={this.debouncedOnSizeToFitChange}
                  checked={sizeToFit}
                  className={isFleetAdvise() || isMobilease() ? "size-to-fit" : ""}
                />
                <SematicCheckbox
                  style={{ paddingLeft: "15px", paddingTop: "10px" }}
                  label={t("showInactiveVehicles")}
                  onChange={(_, e) => {
                    this.setState({ showInactiveVehicles: e.checked })
                    this.loadAllVehicles({
                      page: 1,
                      query: search_text,
                      search_type: selectedOption,
                      is_active: !e.checked
                    })
                  }}
                  checked={this.state.showInactiveVehicles}
                  className={isFleetAdvise() || isMobilease() ? "size-to-fit" : ""}
                />
              </div>
              <VehicleSearch
                dispatch={this.props.dispatch}
                language={language}
                vehicles={vehicles}
                loadAllVehicles={this.loadAllVehicles}
                currentUser={currentUser}
              />
            </div>
            <AgGridReact
              columnDefs={agGridColumnDefs(
                this.defaultCellRenderer,
                this.editCellRenderer,
                this.deleteCellRenderer,
                this.deactivateCellRenderer,
                this.callToActionRenderer,
                t,
                isFleetcor(),
                vehicles,
                this.checkboxBulkRender,
                this.handleBulkCheckBox,
                this.state.rootCheckbox
              )}
              onSortChanged={this.onSortChanged}
              defaultColDef={{
                sortable: true,
                comparator: () => 0,
                filter: false
              }}
              style={{
                height: "80vh !important"
              }}
              getRowNodeId={(data) => data.id} // Provide a unique identifier for each row
              onRowClicked={this.handleRowClick} // Attach the row click event handler
              rowData={agGridRowData(vehicles)}
              rowSelection="single"
              onGridReady={this.onGridReady}
              gridOptions={{
                onFilterChanged: this.setFilteredItems
              }}
              frameworkComponents={{
                customNoRowsOverlay: CustomNoRowsOverlay
              }}
              noRowsOverlayComponent="customNoRowsOverlay"
              noRowsOverlayComponentParams={{
                translationFile: "vehicleIndex",
                label: "noVehiclesInFleetLabel"
              }}
              localeText={language === FR_LOCALE ? frGrid : enGrid}
              quickFilterText={quickFilterText}
              cacheQuickFilter={true}
              pagination={false}
              paginationPageSize={agGridHelpers.PAGINATION_AMOUNT}
              suppressMenuHide={true}
              suppressMovableColumns={false}
              suppressCellSelection={true}
              getRowStyle={getRowStyle}
            ></AgGridReact>
            <div className="ag-paging-panel ag-unselectable">
              <span className="ag-paging-row-summary-panel" aria-hidden="true">
                {(this.state.page - 1 || 0) * 50 + 1} to{" "}
                {Math.min(((this.state.page - 1 || 0) + 1) * 50, this.props.totalVehicleCount)} of{" "}
                {this.props.totalVehicleCount}
              </span>
              <span className="ag-paging-page-summary-panel" role="presentation">
                <div
                  className="ag-paging-button"
                  role="button"
                  onClick={this.goToFirstPage}
                  aria-label="First Page"
                  tabIndex="0"
                >
                  <span className="ag-icon ag-icon-first" role="presentation"></span>
                </div>
                <div
                  className="ag-paging-button"
                  role="button"
                  onClick={this.goToPreviousPage}
                  aria-label="Previous Page"
                  tabIndex="0"
                >
                  <span className="ag-icon ag-icon-previous" role="presentation"></span>
                </div>
                <span className="ag-paging-description" aria-hidden="true">
                  Page <span className="ag-paging-number">{this.state.page}</span> of{" "}
                  <span className="ag-paging-number">{this.props.totalPages}</span>
                </span>
                <div
                  className="ag-paging-button"
                  role="button"
                  onClick={this.goToNextPage}
                  aria-label="Next Page"
                  tabIndex="0"
                >
                  <span className="ag-icon ag-icon-next" role="presentation"></span>
                </div>
                <div
                  className="ag-paging-button"
                  role="button"
                  onClick={this.goToLastPage}
                  aria-label="Last Page"
                  tabIndex="0"
                >
                  <span className="ag-icon ag-icon-last" role="presentation"></span>
                </div>
              </span>
            </div>
          </Segment>
          <Portal open={this.state.openBulkPortal}>
            <div className="bulk-vehicle-portal">
              <BulkActivateDeactivate
                handleVehicleActivation={this.handleVehicleActivation}
                vehicles={this.props.vehicles}
                isBulkApiInProgress={this.props.isBulkApiInProgress}
                checkedVehicles={this.state.checkedVehicles}
              />
            </div>
          </Portal>
        </div>
      </ApplicationLayout>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    vehicles: (state.vehicles.vehicles ?? []).map((vehicle, i) => {
      vehicle.index = i
      return vehicle
    }),
    currentUser: state.application.userSessionData || state.users.currentUser,
    language:
      (state.application.userSessionData && state.application.userSessionData.language) ||
      state.users.currentUser
        ? state.users.currentUser.language
        : "",
    totalVehicleCount: state.vehicles.total_vehicle_count,
    totalPages: state.vehicles.total_pages,
    fleet: state.application.fleetSessionData || state.fleets.fleet
  }
}

export default connect(mapStateToProps)(withTranslation("vehicleIndex")(withRouter(VehicleIndex)))
